export interface blogPost {
  excerpt: string;
  coverImage: string;
  cardImageAlt: string;
  relatedDepartments: string[];
  linkCopy: string;
  linkType: string;
  linkHref: string;
  backgroundColor: string;
}

export const blogPosts: blogPost[] = [
  {excerpt:"Your website. It’s a bit of an animal",coverImage:"./images/ADM_Blog_1.webp",cardImageAlt:"",relatedDepartments:["Technology"],linkCopy:"Read more",linkType:"external",linkHref:"https://www.addmustard.com/blog/your-website-its-a-bit-of-an-animal/",backgroundColor:"#000"},
  {excerpt:"Understand the origins of your audience. Martini, Beatle and Spice?",coverImage:"./images/ADM_Blog_2.webp",cardImageAlt:"",relatedDepartments:["Brand"],linkCopy:"Read more",linkType:"external",linkHref:"https://www.addmustard.com/blog/martini-beatle-and-spice/",backgroundColor:"#000"},
  {excerpt:"Does my brand look big in this?",coverImage:"./images/ADM_Blog_3.webp",cardImageAlt:"",relatedDepartments:["Marketing"],linkCopy:"Read more",linkType:"external",linkHref:"https://www.addmustard.com/blog/does-my-brand-look-big-in-this/",backgroundColor:"#000"},
];
